import client from "../server/Client";
import {useQuery} from "@tanstack/react-query";

const termsAndConditions = (formTypeId) => client.get(`forms/${formTypeId}/termsAndConditions`);
export const useTermsAndConditions = ({formTypeId}) => useQuery(['terms', formTypeId],
    () => termsAndConditions(formTypeId),
    {select: data => data?.data?.result})